<template>
  <qx-card-form :title="title" v-show="userInfo">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      title: '邀请成为招商车司机',
      userInfo: null,
      carUserType: null,
      baseForm: {
        plateNumbersOptions: [],
        form: [
          {
            label: '申请说明',
            value: 'applyRemark',
            type: 'input',
            hide: false,
          },
          {
            label: '选择合作车辆',
            value: 'plateNumbers',
            type: 'select',
            multiple: true,
            hide: true,
          },
          {
            label: '附件',
            value: 'applyFile',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
            hide: false,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.userInfo = val.userInfo;
      if (val.vehicleList) {
        this.baseForm.plateNumbersOptions = val.vehicleList.map((item) => ({
          label: item.plateNumber,
          value: item.plateNumber,
        }));
      }
      this.carUserType = val.carUserType;
      switch (val.carUserType) {
        case '1':
          this.title = '申请转移自有车司机';
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'label',
            value: '申请说明',
            names: ['applyRemark'],
          });
          break;
        case '2':
          this.title = '邀请成为招商车司机';
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'label',
            value: '邀请说明',
            names: ['applyRemark'],
          });
          break;
        case '3':
          this.title = '选择合作车辆';
          break;
        case '4':
          this.title = '邀请成为挂靠车司机';
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'label',
            value: '邀请说明',
            names: ['applyRemark'],
          });
          break;
        default:
          break;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: val.carUserType === '3',
        names: ['applyRemark', 'applyFile'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: val.carUserType !== '3',
        names: ['plateNumbers'],
      });
    },

    async sub () {
      if (!this.userInfo) {
        return {};
      } else {
        const formData = await this.$refs.baseForm.sub();
        if (formData) {
          if (formData.plateNumbers) {
            formData.plateNumbers = formData.plateNumbers.join(',');
          }
          delete formData.plateNumbers;
          if (formData.applyFile && formData.applyFile[0]) {
            formData.applyFileId = formData.applyFile[0].id;
          }
          delete formData.applyFile;
          formData.tenantId = this.userInfo.tenantId;
          formData.busiId = this.userInfo.userId;
          formData.isApply = true;
        }
        return formData;
      }
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 16px;
  color: #999;
  span{
    color: #666;
    margin-right: 8px;
  }
}
</style>
